import { render } from "./CodeHighlighter.vue?vue&type=template&id=04d89187"
import script from "./CodeHighlighter.vue?vue&type=script&lang=ts"
export * from "./CodeHighlighter.vue?vue&type=script&lang=ts"
script.render = render

export default script